import { SMALL_GALLERIES, SMALL_GALLERIES_BY_KEY } from "../data/small-gallery";
import type { SmallGalleryBlock, SmallGalleryBlockKey } from "../types";

export function getSmallGallery(key: SmallGalleryBlockKey): SmallGalleryBlock {
  return SMALL_GALLERIES_BY_KEY[key];
}

type GetSmallGalleriesOptions = {
  limit?: number;
};

export function getSmallGalleries(
  keys?: SmallGalleryBlockKey | SmallGalleryBlockKey[],
  options?: GetSmallGalleriesOptions,
): SmallGalleryBlock[] {
  if (!keys) {
    return SMALL_GALLERIES.slice(0, options?.limit);
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list
    .map(key => SMALL_GALLERIES_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}
